(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CampaignsController', CampaignsController);

    function CampaignsController($window, $translate, $localStorage, $uibModal, Principal, CampaignService, toastr, ModalFactory, $state, paginationConstants, systemConstants, MODAL_CONTENT_TYPES) {
        var vm = this;

        var INACTIVE_CAMPAINGN = 'INACTIVE';
        var PENDING_CAMPAIGN = 'PENDING';
        var storeId = $localStorage.defaultStore.storeId;
        var userId = $localStorage.userId;
        var campaignsLocalStorageKey = 'campaignlistFilter_' + userId + '_' + storeId;
        var campaignsOrderLocalStorageKey = 'campaignlistOrder_' + userId + '_' + storeId;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        vm.currentPage = 1;
        vm.numPerPage = 20;
        vm.maxSize = 5;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };
        vm.itemsPerPageOptions = paginationConstants.itemsPerPageOptions;

        vm.account = undefined;
        vm.userProfile = undefined;

        vm.loadingCampaings = false;
        vm.campaignsList = [];

        vm.totalInvoices = vm.campaignsList.length;

        vm.campaignToAction = null;

        vm.statusMap = {
            PENDING: 'PENDING',
            DOING: 'DOING',
            DONE: 'DONE',
            EMPTY: 'EMPTY',
            EXPIRED: 'EXPIRED',
            INACTIVE: 'INACTIVE',
            NEW: 'NEW',
            SCHEDULED: 'SCHEDULED'
        };

        vm.deadlineMap = {
            NORMAL: 'NORMAL',
            MEDIAN: 'MEDIAN',
            URGENT: 'URGENT',
            INDETERMINATE: 'INDETERMINATE'
        };

        vm.status = [
            {
                id: vm.statusMap.SCHEDULED,
                label: $translate.instant('campaign.list.status.scheduled')
            },
            {
                id: vm.statusMap.PENDING,
                label: $translate.instant('seller-campaigns.list.badges.pending')
            },
            {
                id: vm.statusMap.DOING,
                label: $translate.instant('campaign.list.status.doing')
            },
            {
                id: vm.statusMap.DONE,
                label: $translate.instant('campaign.list.status.done')
            },
            {
                id: vm.statusMap.EMPTY,
                label: $translate.instant('seller-campaigns.list.badges.empty')
            },
            {
                id: vm.statusMap.EXPIRED,
                label: $translate.instant('campaign.list.status.expired')
            },
            {
                id: vm.statusMap.INACTIVE,
                label: $translate.instant('campaign.list.status.inactive')
            }
        ];

        vm.statusHub = [
            {
                id: vm.statusMap.PENDING,
                label: $translate.instant('campaign.list.status.active')
            },
            {
                id: vm.statusMap.NEW,
                label: $translate.instant('campaign.list.status.new')
            },
            {
                id: vm.statusMap.INACTIVE,
                label: $translate.instant('campaign.list.status.inactive')
            },
        ]

        vm.filter = !angular.isUndefined($localStorage[campaignsLocalStorageKey]) ? $localStorage[campaignsLocalStorageKey] : {
            status: [],
            search: "",
            orderBy: 'expirationDate',
            orderDirection: "asc",
            deadline: ""
        };

        vm.deadline = [
            {
                value: vm.deadlineMap.NORMAL,
                label: $translate.instant('seller-campaigns.list.deadlines.normal')
            },
            {
                value: vm.deadlineMap.MEDIAN,
                label: $translate.instant('seller-campaigns.list.deadlines.median')
            },
            {
                value: vm.deadlineMap.URGENT,
                label: $translate.instant('seller-campaigns.list.deadlines.urgent')
            },
            {
                value: vm.deadlineMap.INDETERMINATE,
                label: $translate.instant('seller-campaigns.list.deadlines.indeterminate')
            }
        ];

        vm.getSortOptions = [
            {id: 0, label: $translate.instant('seller-campaigns.filter.order-by'), value: "name", direction: 'asc'},
            {id: 1, label: "A-Z", value: "name", direction: 'asc'},
            {id: 2, label: "Z-A", value: "name", direction: 'desc'},
            {id: 3, label: $translate.instant('seller-campaigns.filter.deadline'), value: "expirationDate", direction: 'asc'},
            {id: 4, label: $translate.instant('seller-campaigns.filter.newly-registered'), value: "createdDate", direction: 'desc'},
        ];

        vm.moreActions = [
            {
                name: 'settings',
                icon: 'icon-ksc-gear-light',
                label: 'campaign.settings.action',
                method: function () {
                    vm.openCampaignSettings();
                }
            }
        ];

        var requestSeq = 0;
        var lastRequestSignature = null;

        init();

        function init() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                    vm.statusOptions = vm.account.isHubAdmin ? vm.statusHub : vm.status;
                    vm.filter.status = [];
                }
            });
            getCampaigns(vm.paginationOptions, vm.filter);
        }

        function getCampaigns(pagination, filter) {

            var params = angular.copy(filter);
            var formatedStatusFilter = params.status.map(function (item) {
                return item.id;
            });
            var formattedDeadline = params.deadline ? params.deadline.value : "";
            params.page = pagination.page;
            params.size = pagination.size;
            params.status = formatedStatusFilter;
            params.deadline = formattedDeadline;

            var signature = JSON.stringify({
                page: params.page,
                size: params.size,
                status: params.status,
                search: params.search,
                orderBy: params.orderBy,
                orderDirection: params.orderDirection,
                deadline: params.deadline
            });
            if (signature === lastRequestSignature && vm.loadingCampaings) {
                return;
            }
            lastRequestSignature = signature;
            var seq = ++requestSeq;
            vm.loadingCampaings = true;

            CampaignService.listAll(params).then(function (response) {
                if (seq !== requestSeq) {
                    return;
                }
                vm.campaignsList = response.data.campaigns;
                vm.totalCampaigns = response.data.total;
                updatePaginationInfo();
                setOpenUpFlags(vm.campaignsList);

                vm.loadingCampaings = false;
            }).catch(function () {
                if (seq !== requestSeq) {
                    return;
                }
                vm.loadingCampaings = false;
            });
        }

        function clearPaginationInfo() {
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        function setOpenUpFlags(list) {
            if (!list || list.length < 3) {
                for (var i = 0; i < list.length; i++) {
                    list[i].openUp = false;
                }
                return;
            }

            var lastIndex = list.length - 1;
            var penultimateIndex = lastIndex - 1;

            for (var i = 0; i < list.length; i++) {
                list[i].openUp = (i === lastIndex || i === penultimateIndex);
            }
        }

        vm.loadFilter = function () {
            clearPaginationInfo();
            getCampaigns(vm.paginationOptions, vm.filter);
            $localStorage[campaignsLocalStorageKey] = vm.filter;
        };

        vm.onChangeItemsPerPage = function (newValue) {
            if (newValue == null || newValue === vm.numPerPage) {
                return;
            }
            clearPaginationInfo();
            vm.numPerPage = newValue;
            vm.changePage();
        };

        vm.onChangeDeadline = function(value) {
            var nextDeadline = value ? vm.deadline.find(function (item) {
                if (!item) return false;
                return item.value === value;
            }) : null;
            var currentValue = vm.filter.deadline && vm.filter.deadline.value ? vm.filter.deadline.value : null;
            var nextValue = nextDeadline && nextDeadline.value ? nextDeadline.value : null;
            vm.filter.deadline = nextDeadline;
            if (currentValue === nextValue) {
                return;
            }
            vm.loadFilter();
        };

        vm.onSelectedSortOption = function (newValue) {
            if (newValue.id !== 0) {
                var sameOrder = vm.filter.orderBy === newValue.value && vm.filter.orderDirection === newValue.direction;
                vm.filter.orderBy = newValue.value;
                vm.filter.orderDirection = newValue.direction;
                $localStorage[campaignsOrderLocalStorageKey] = newValue;
                if (sameOrder) {
                    return;
                }
                vm.loadFilter();
            }
        };

        vm.changePage = function () {
            vm.paginationOptions.page = vm.currentPage - 1;
            vm.paginationOptions.size = vm.numPerPage;

            getCampaigns(vm.paginationOptions, vm.filter);
        };

        function updatePaginationInfo() {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;
            vm.startRegistry = begin + 1;
            vm.endRegistry = Math.min(end, vm.totalCampaigns);
        }

        vm.filterCampaigns = function() {
            vm.filter.status = vm.filter.status === "" ? null : vm.filter.status;
            vm.currentPage = 1;

            vm.paginationOptions.page = vm.currentPage - 1;

            getCampaigns(vm.paginationOptions, vm.filter);
        };

        vm.openDeleteModal = function (campaign) {
            vm.campaignToAction = campaign;
            ModalFactory.openWarningModal(
                null,
                $translate.instant('campaign.remove.content'),
                null,
                null,
                $translate.instant('campaign.remove.button.confirm'),
                $translate.instant('entity.action.cancel'),
                vm.deleteCampaign
            );
        };

        vm.deleteCampaign = function () {
            CampaignService.deleteCampaign(vm.campaignToAction.id).then(function (response) {
                toastr.success($translate.instant('campaign.remove.success'));
                getCampaigns(vm.paginationOptions, vm.filter);
            });
        };

        vm.openActivateOrInactivateCampaignModal = function (campaign) {
            vm.campaignToAction = campaign;
            ModalFactory.openWarningModal(
                null,
                $translate.instant(campaign.status !== INACTIVE_CAMPAINGN ? 'campaign.activate-inactivate.inactivate.content' :  'campaign.activate-inactivate.activate.content'),
                null,
                null,
                $translate.instant(campaign.status !== INACTIVE_CAMPAINGN ? 'campaign.action.inactivate' : 'campaign.action.activate'),
                $translate.instant('entity.action.cancel'),
                vm.inactivateOrActivate
            );
        };

        vm.goToDistribute = function (campaignId) {
            $state.go('campaign.distribute', { id: campaignId });
        };

        vm.inactivateOrActivate = function () {
            var newStatus = vm.campaignToAction.status !== INACTIVE_CAMPAINGN ? INACTIVE_CAMPAINGN : PENDING_CAMPAIGN;

            CampaignService.activateOrInactivate(vm.campaignToAction.id, { isActive: vm.campaignToAction.isActive, status: newStatus }).then(function (result) {
                getCampaigns(vm.paginationOptions, vm.filter);
                if (vm.campaignToAction.status !== INACTIVE_CAMPAINGN) {
                    toastr.success($translate.instant('campaign.activate-inactivate.inactivate.success'));
                } else {
                    toastr.success($translate.instant('campaign.activate-inactivate.activate.success'));
                }
            });
        };

        vm.openViewCampaignMenu = function (campaign) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            campaign: campaign,
                            isHub: vm.account.isHubAdmin,
                            type: MODAL_CONTENT_TYPES.CAMPAIGN
                        }
                    }
                }
            }).result.then();
        };

        vm.openCampaignSettings = function () {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            type: MODAL_CONTENT_TYPES.CAMPAIGN_SETTINGS,
                            title: $translate.instant('campaign.settings.title'),
                            cancelButtonText: $translate.instant('entity.action.cancel'),
                            confirmButtonText: $translate.instant('entity.action.save')
                        }
                    }
                }
            }).result.then();
        };

        vm.textEllipsis = function (text, length) {
            if (text.length > length) {
                return text.substring(0, length) + '...';
            }
            return text;
        };

        vm.openConfirmDuplicateModal = function (campaign) {
            vm.campaignToAction = campaign;
            ModalFactory.openWarningModal(
                null,
                $translate.instant('campaign.duplicate.message.content'),
                null,
                null,
                $translate.instant('entity.action.confirm'),
                $translate.instant('entity.action.cancel'),
                vm.duplicate
            );
        };

        vm.duplicate = function () {
            $state.go('campaign.duplicate', { id: vm.campaignToAction.id });
        };
    }
})();
